<div class="dropdown" [class.dropdown--open]="_open">
    <button type="button" class="dropdown-trigger"
            (click)="$event.stopPropagation(); toggle()">
        <span class="dropdown-label">{{ label }}</span>
        <span class="dropdown-chev" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="#ffffff" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
    </button>

    <ul class="dropdown-menu" *ngIf="_open" (click)="$event.stopPropagation()">
        <li *ngFor="let item of visibleItems; trackBy: trackByLabel">
            <button type="button" class="dropdown-item" (click)="select(item)">
                <span class="dropdown-item__icon" aria-hidden="true">
                    <svg *ngIf="item.icon === 'plus'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5v14M5 12h14" stroke="#1E293B" stroke-width="1.8" stroke-linecap="round"/>
                    </svg>
                    <svg *ngIf="item.icon === 'file'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z"
                              stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M14 3v5h5" stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                    </svg>
                    <svg *ngIf="item.icon === 'file-pdf'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z"
                              stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M14 3v5h5" stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                        <text x="8" y="18" font-family="Arial, sans-serif" font-size="6"
                              font-weight="700" fill="#1E293B">PDF</text>
                    </svg>
                    <svg *ngIf="item.icon === 'eye'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"
                              stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                        <circle cx="12" cy="12" r="3" stroke="#1E293B" stroke-width="1.6"/>
                    </svg>
                    <svg *ngIf="item.icon === 'card'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="5" width="20" height="14" rx="2"
                              stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round"/>
                        <path d="M2 10h20" stroke="#1E293B" stroke-width="1.6"/>
                        <path d="M6 15h4" stroke="#1E293B" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                    <svg *ngIf="item.icon === 'bank'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M3 10h18M3 10L12 3l9 7M3 10v10h18V10"
                              stroke="#1E293B" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
                        <path d="M9 14v6M15 14v6" stroke="#1E293B" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                </span>
                <span class="dropdown-item__label">{{ item.label }}</span>
                <span class="dropdown-item__chev" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M9 6l6 6-6 6" stroke="#1E293B" stroke-width="1.8"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </button>
        </li>
    </ul>
</div>
